import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';
import { DropdownMenu } from './DropdownMenu';

export interface IDropdownActionItemProps {
  description: string;
  className?: ClassValue;
  icon?: React.ReactNode;
  disabled?: boolean;
  danger?: boolean;
  onClick(): void;
  selected?: boolean;
}

export default function DropdownActionItem({
  description,
  className,
  icon,
  disabled,
  danger,
  selected = false,
  onClick,
}: IDropdownActionItemProps) {
  return (
    <DropdownMenu.Item
      className={cn('p-0', className)}
      onClick={() => {
        if (!disabled) onClick();
      }}
      disabled={disabled}
      danger={danger}
    >
      <div
        className={cn(
          'flex min-w-40 items-center gap-2 rounded-md p-2',
          selected &&
            'border border-green-600 text-green-600 dark:border-green-400 dark:text-green-400',
          disabled && 'cursor-default',
        )}
      >
        <div
          className={cn(
            'border-border-default rounded-lg border p-1',
            selected && 'text-green-600 dark:text-green-400',
          )}
        >
          {icon}
        </div>
        <p
          className={cn(
            'text-text-primary text-base',
            selected && 'font-semibold text-green-600 dark:text-green-400',
          )}
        >
          {description}
        </p>
      </div>
    </DropdownMenu.Item>
  );
}
